import $ from 'jquery';
class Members {
    constructor(){
        if ($("#approved-member-list").length != 0){
            this.events();
        }
    }

    events() {

        $(".member-in-list").on("click", this.memberSelected.bind(this));    // Members Name Clicked
        $("#members-tab-general").on("click", this.tabSelected.bind(this));    // Member Type Tab Clicked
        $("#members-tab-waiting").on("click", this.tabSelected.bind(this));    // Member Type Tab Clicked
        $("#members-tab-guests").on("click", this.tabSelected.bind(this));    // Member Type Tab Clicked
        $("#members-tab-dormant").on("click", this.tabSelected.bind(this));    // Member Type Tab Clicked
    }

    tabSelected(e){
        resetTabs();
        var selectedTab = $(e.target).closest('section');
        selectedTab.addClass('tab-active');
        switch (selectedTab.data('tab')){
            case 0:
                $('#member-approved-section').removeClass('d-none');
                break;
            case 1:
                $('#member-pending-section').removeClass('d-none');
                break;
            case 2:
                $('#member-guest-section').removeClass('d-none');
                break;
            case 3:
                $('#member-dormant-section').removeClass('d-none');
                break;
        }

    }
    memberSelected(e){
        $('#membersDialogList').empty();

        var restData = {
            'MEMBER-ID': $(e.target).data('id')
        };
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/getMemberDialogDetails/',
            type: 'GET',
            data: restData,
            success: (response) => {
                $("#membersDialog").dialog({
                autoOpen: false,
                show: {
                    effect: "blind",
                    duration: 1000
                },
                hide: {
                    effect: "explode",
                    duration: 1000
                },
                buttons: [
                    {
                        text: 'Close',
                        click: function() {
                            $(this).dialog("close");
                        }
                    }
                ],
                modal: false,
                width: 'auto'
                });

                if (response['MEMBER-REG-COUNT'] > 0){
                    $('#membersDialogSailorTitle').removeClass('d-none');
                    $('#membersDialogRegCount').removeClass('d-none');
                } else {
                    $('#membersDialogSailorTitle').addClass('d-none');
                    $('#membersDialogRegCount').addClass('d-none');
                }
                var sailorArray = response['MEMBER-SAILORS'].split(',');
                $('#membersDialogName').text(response['MEMBER-NAME']);
                $('#membersDialogNiceName').text(response['MEMBER-NICE-NAME']);
                $('#membersDialogEmail').text(response['MEMBER-EMAIL']);
                $('#membersDialogRegCount').text("Total Event Registrations: " + response['MEMBER-REG-COUNT']);
                for (const sailor of sailorArray){
                    $('#membersDialogList').append("<li>" + sailor + "</li>");
                }
                $('#membersDialog').dialog("open");
            },
            error: (response) => {
                console.log("Unable to get Member");
                console.log(response);
            }
        });
    }
}

function resetTabs(){
    $('#members-tab-general').removeClass('tab-active');
    $('#members-tab-waiting').removeClass('tab-active');
    $('#members-tab-guests').removeClass('tab-active');
    $('#members-tab-dormant').removeClass('tab-active');
    $('#member-guest-section').addClass('d-none');
    $('#member-pending-section').addClass('d-none');
    $('#member-approved-section').addClass('d-none');
    $('#member-dormant-section').addClass('d-none');

}

export default Members;